import React from 'react';

import BaseForm from 'components/BaseForm/BaseForm';
import FiltersSubForms from 'components/FiltersSubForms';
import { useApi } from 'hooks/ApiStoreContext';
import { useEnvironnement } from 'hooks/EnvironementStoreContext';
import { useGFFilterContext } from 'hooks/GFFilterStoreContext';
import { CSSUtils } from 'utils/CSSUtils';

import { FormFilterGardien } from '../types';

import { FormFooter } from './FormFooter/FormFooter';

interface Props {
  setFilter: (value: Partial<FormFilterGardien>) => void;
  filter: Partial<FormFilterGardien>;
}

export function FilterFormGardien({
  setFilter,
  filter,
}: Props): React.ReactElement {
  const { ReferentielControllerApi: refController } = useApi();

  const [, , actionsRequises] = useGFFilterContext();

  const [{ JUSTICE_ACTIVE_BOOL }] = useEnvironnement();

  const initialsFilter = { ...filter };

  const subForms = FiltersSubForms(refController, actionsRequises);

  return (
    <BaseForm
      initialValues={initialsFilter}
      onChange={(changed, all: Partial<FormFilterGardien>) => {
        return {
          ...all,
          idModele: changed.idMarque ? undefined : all.idModele,
        };
      }}
      subForms={[
        {
          title: 'Général',
          inputs: [
            subForms.statut,
            subForms.classement,
            subForms.actionsRequises,

            ...(JUSTICE_ACTIVE_BOOL
              ? ([subForms.idJuridictionList] as const)
              : []),
            subForms.includeDossiersAnonymises,
            subForms.includeOnlyNotDetruitApresSorti,
          ],
        },
        {
          title: 'Mise en fourrière',
          inputs: [
            subForms.natureMiseEnFourriere,
            subForms.dateRangeMiseEnFourriere,
            subForms.dateRangeMiseAJour,
          ],
        },
        {
          title: 'Suivi de mise en fourrière',
          inputs: [subForms.motifDeSortie],
        },
        {
          title: 'Véhicule',
          inputs: [subForms.marque, subForms.modele],
        },
      ]}
      onSubmit={() => Promise.resolve()}
      renderButtonAction={() => <FormFooter setFilter={setFilter} />}
      wrapperCol={{ span: CSSUtils.LlargeWrapperCol }}
    />
  );
}
